import {
  generateSkinDefaults,
  cssPropertyToDefaultValueMap,
} from '@wix/editor-elements-panel';
import type { legacyStylePropertiesTypes } from '@wix/editor-elements-panel/src/adapters/constants';
import type { SkinDefinition } from '@wix/editor-elements-panel/src/adapters/types';

const rootParams = {
  'border-left': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  'border-right': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  'border-top': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  'border-bottom': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  background: {
    type: 'BACKGROUND_FILL' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '#ffffff',
    state: 'regular',
  },
  'box-shadow': {
    type: 'BOX_SHADOW' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '',
    state: 'regular',
  },
  'border-top-left-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0',
    state: 'regular',
  },
  'border-top-right-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0',
    state: 'regular',
  },
  'border-bottom-left-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0',
    state: 'regular',
  },
  'border-bottom-right-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0',
    state: 'regular',
  },
  'padding-left': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
  'padding-right': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
  'padding-top': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
  'padding-bottom': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
};

const rootHoverParams = {
  'hover-border-left': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'hover-border-right': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'hover-border-top': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'hover-border-bottom': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'hover-background': {
    type: 'BACKGROUND_FILL' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'hover-box-shadow': {
    type: 'BOX_SHADOW' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'hover-border-top-left-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'hover-border-top-right-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'hover-border-bottom-left-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'hover-border-bottom-right-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'hover-padding-left': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'hover-padding-right': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'hover-padding-top': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'hover-padding-bottom': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
};

const itemParams = {
  'item-border-left': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  'item-border-right': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  'item-border-top': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  'item-border-bottom': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  'item-background': {
    type: 'BACKGROUND_FILL' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '#ffffff',
    state: 'regular',
  },
  'item-box-shadow': {
    type: 'BOX_SHADOW' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
  'item-border-top-left-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0',
    state: 'regular',
  },
  'item-border-top-right-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0',
    state: 'regular',
  },
  'item-border-bottom-left-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0',
    state: 'regular',
  },
  'item-border-bottom-right-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0',
    state: 'regular',
  },
  'item-padding-left': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
  'item-padding-right': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
  'item-padding-top': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
  'item-padding-bottom': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
};

const itemHoverParams = {
  'item-hover-border-left': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'item-hover-border-right': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'item-hover-border-top': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'item-hover-border-bottom': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'item-hover-background': {
    type: 'BACKGROUND_FILL' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'item-hover-hover-background': {
    type: 'BACKGROUND_FILL' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'item-hover-box-shadow': {
    type: 'BOX_SHADOW' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'item-hover-border-top-left-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'item-hover-border-top-right-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'item-hover-border-bottom-left-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'item-hover-border-bottom-right-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'item-hover-padding-left': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'item-hover-padding-right': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'item-hover-padding-top': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'item-hover-padding-bottom': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
};

const titleParams = {
  'title-text-display': {
    type: 'DISPLAY' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: 'block',
    state: 'regular',
  },
  'title-text-align': {
    type: 'TEXT_ALIGN' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: 'revert',
    state: 'regular',
  },
  'title-text-highlight': {
    type: 'CSS_COLOR' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: 'none',
    state: 'regular',
  },
  'title-text-transform': {
    type: 'TEXT_TRANSFORM' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: 'none',
    state: 'regular',
  },
  'title-text-outline': {
    type: 'TEXT_OUTLINE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue:
      '1px 0px transparent, -1px 0px transparent, 0px 1px transparent, 0px -1px transparent',
    state: 'regular',
  },
  'title-text-shadow': {
    type: 'TEXT_SHADOW' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '',
    state: 'regular',
  },
  'title-font': {
    type: 'FONT' as (typeof legacyStylePropertiesTypes)[number],
    state: 'regular',
    defaultValue: 'font_6',
  },
  'title-color': {
    type: 'CSS_COLOR' as (typeof legacyStylePropertiesTypes)[number],
    state: 'regular',
    defaultValue: 'rgba(0,0,0)',
  },
  'title-letter-spacing': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'regular',
    defaultValue: '1em',
  },
  'title-line-height': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'regular',
    defaultValue: '1.4em',
  },
  'title-text-decoration': {
    type: 'TEXT_DECORATION_LINE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'regular',
    defaultValue: 'none',
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'title-direction': {
    type: 'DIRECTION' as (typeof legacyStylePropertiesTypes)[number],
    state: 'regular',
    defaultValue: 'ltr',
  },
  'title-padding-bottom': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
  'title-padding-top': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
  'title-padding-left': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
  'title-padding-right': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
};

const titleHoverParams = {
  'title-hover-text-display': {
    type: 'DISPLAY' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'title-hover-text-align': {
    type: 'TEXT_ALIGN' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'title-hover-text-highlight': {
    type: 'CSS_COLOR' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'title-hover-text-transform': {
    type: 'TEXT_TRANSFORM' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'title-hover-text-outline': {
    type: 'TEXT_OUTLINE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'title-hover-text-shadow': {
    type: 'TEXT_SHADOW' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'title-hover-font': {
    type: 'FONT' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'title-hover-color': {
    type: 'CSS_COLOR' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'title-hover-letter-spacing': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'title-hover-line-height': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'title-hover-text-decoration': {
    type: 'TEXT_DECORATION_LINE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'title-hover-direction': {
    type: 'DIRECTION' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'title-hover-padding-bottom': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'title-hover-padding-top': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'title-hover-padding-left': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'title-hover-padding-right': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
};

const descriptionParams = {
  'description-text-display': {
    type: 'DISPLAY' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: 'block',
    state: 'regular',
  },
  'description-text-align': {
    type: 'TEXT_ALIGN' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: 'revert',
    state: 'regular',
  },
  'description-text-highlight': {
    type: 'CSS_COLOR' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: 'none',
    state: 'regular',
  },
  'description-text-transform': {
    type: 'TEXT_TRANSFORM' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: 'none',
    state: 'regular',
  },
  'description-text-outline': {
    type: 'TEXT_OUTLINE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue:
      '1px 0px transparent, -1px 0px transparent, 0px 1px transparent, 0px -1px transparent',
    state: 'regular',
  },
  'description-text-shadow': {
    type: 'TEXT_SHADOW' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '',
    state: 'regular',
  },
  'description-font': {
    type: 'FONT' as (typeof legacyStylePropertiesTypes)[number],
    state: 'regular',
    defaultValue: 'font_6',
  },
  'description-color': {
    type: 'CSS_COLOR' as (typeof legacyStylePropertiesTypes)[number],
    state: 'regular',
    defaultValue: 'rgba(0,0,0)',
  },
  'description-letter-spacing': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'regular',
    defaultValue: '1em',
  },
  'description-line-height': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'regular',
    defaultValue: '1.4em',
  },
  'description-text-decoration': {
    type: 'TEXT_DECORATION_LINE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'regular',
    defaultValue: 'none',
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'description-direction': {
    type: 'DIRECTION' as (typeof legacyStylePropertiesTypes)[number],
    state: 'regular',
    defaultValue: 'ltr',
  },
  'description-padding-bottom': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
  'description-padding-top': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
  'description-padding-left': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
  'description-padding-right': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
};

const descriptionHoverParams = {
  'description-hover-text-display': {
    type: 'DISPLAY' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'description-hover-text-align': {
    type: 'TEXT_ALIGN' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'description-hover-text-highlight': {
    type: 'CSS_COLOR' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'description-hover-text-transform': {
    type: 'TEXT_TRANSFORM' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'description-hover-text-outline': {
    type: 'TEXT_OUTLINE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'description-hover-text-shadow': {
    type: 'TEXT_SHADOW' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'description-hover-font': {
    type: 'FONT' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'description-hover-color': {
    type: 'CSS_COLOR' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'description-hover-letter-spacing': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'description-hover-line-height': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'description-hover-text-decoration': {
    type: 'TEXT_DECORATION_LINE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'description-hover-direction': {
    type: 'DIRECTION' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'description-hover-padding-bottom': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'description-hover-padding-top': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'description-hover-padding-left': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'description-hover-padding-right': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
};

const counterParams = {
  'counter-text-display': {
    type: 'DISPLAY' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: cssPropertyToDefaultValueMap.display,
    state: 'regular',
  },
  'counter-text-align': {
    type: 'TEXT_ALIGN' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: cssPropertyToDefaultValueMap['text-align'],
    state: 'regular',
  },
  'counter-text-highlight': {
    type: 'CSS_COLOR' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: cssPropertyToDefaultValueMap.none,
    state: 'regular',
  },
  'counter-text-transform': {
    type: 'TEXT_TRANSFORM' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: cssPropertyToDefaultValueMap['text-transform'],
    state: 'regular',
  },
  'counter-text-outline': {
    type: 'TEXT_OUTLINE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: cssPropertyToDefaultValueMap['text-outline'],
    state: 'regular',
  },
  'counter-text-shadow': {
    type: 'TEXT_SHADOW' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: cssPropertyToDefaultValueMap['text-shadow'],
    state: 'regular',
  },
  'counter-font': {
    type: 'FONT' as (typeof legacyStylePropertiesTypes)[number],
    state: 'regular',
    defaultValue: cssPropertyToDefaultValueMap.font,
  },
  'counter-color': {
    type: 'CSS_COLOR' as (typeof legacyStylePropertiesTypes)[number],
    state: 'regular',
    defaultValue: cssPropertyToDefaultValueMap.color,
  },
  'counter-letter-spacing': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'regular',
    defaultValue: cssPropertyToDefaultValueMap['letter-spacing'],
  },
  'counter-line-height': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'regular',
    defaultValue: cssPropertyToDefaultValueMap['line-height'],
  },
  'counter-text-decoration': {
    type: 'TEXT_DECORATION_LINE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'regular',
    defaultValue: cssPropertyToDefaultValueMap['text-decoration'],
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'counter-direction': {
    type: 'DIRECTION' as (typeof legacyStylePropertiesTypes)[number],
    state: 'regular',
    defaultValue: cssPropertyToDefaultValueMap.direction,
  },
  'counter-padding-bottom': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: cssPropertyToDefaultValueMap['padding-bottom'],
    state: 'regular',
  },
  'counter-padding-top': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: cssPropertyToDefaultValueMap['padding-top'],
    state: 'regular',
  },
  'counter-padding-left': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: cssPropertyToDefaultValueMap['padding-left'],
    state: 'regular',
  },
  'counter-padding-right': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: cssPropertyToDefaultValueMap['padding-right'],
    state: 'regular',
  },
};

const counterHoverParams = {
  'counter-hover-text-display': {
    type: 'DISPLAY' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'counter-hover-text-align': {
    type: 'TEXT_ALIGN' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'counter-hover-text-highlight': {
    type: 'CSS_COLOR' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'counter-hover-text-transform': {
    type: 'TEXT_TRANSFORM' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'counter-hover-text-outline': {
    type: 'TEXT_OUTLINE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'counter-hover-text-shadow': {
    type: 'TEXT_SHADOW' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'counter-hover-font': {
    type: 'FONT' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'counter-hover-color': {
    type: 'CSS_COLOR' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'counter-hover-letter-spacing': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'counter-hover-line-height': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'counter-hover-text-decoration': {
    type: 'TEXT_DECORATION_LINE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'counter-hover-direction': {
    type: 'DIRECTION' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'counter-hover-padding-bottom': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'counter-hover-padding-top': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'counter-hover-padding-left': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'counter-hover-padding-right': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
};

const overlayParams = {
  'overlay-border-left': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  'overlay-border-right': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  'overlay-border-top': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  'overlay-border-bottom': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  'overlay-background': {
    type: 'BACKGROUND_FILL' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '#ffffff',
    state: 'regular',
  },
  'overlay-border-top-left-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0',
    state: 'regular',
  },
  'overlay-border-top-right-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0',
    state: 'regular',
  },
  'overlay-border-bottom-left-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0',
    state: 'regular',
  },
  'overlay-border-bottom-right-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0',
    state: 'regular',
  },
};

const overlayHoverParams = {
  'overlay-hover-border-left': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'overlay-hover-border-right': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'overlay-hover-border-top': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'overlay-hover-border-bottom': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'overlay-hover-background': {
    type: 'BACKGROUND_FILL' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'overlay-hover-border-top-left-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'overlay-hover-border-top-right-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'overlay-hover-border-bottom-left-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'overlay-hover-border-bottom-right-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
};

const imageParams = {
  'image-background': {
    type: 'BACKGROUND_FILL' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '#ffffff',
    state: 'regular',
  },
  'image-border-left': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  'image-border-right': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  'image-border-top': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  'image-border-bottom': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  'image-border-top-left-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0',
    state: 'regular',
  },
  'image-border-top-right-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0',
    state: 'regular',
  },
  'image-border-bottom-left-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0',
    state: 'regular',
  },
  'image-border-bottom-right-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0',
    state: 'regular',
  },
  'image-padding-left': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
  'image-padding-right': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
  'image-padding-top': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
  'image-padding-bottom': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '0px',
    state: 'regular',
  },
  'image-box-shadow': {
    type: 'BOX_SHADOW' as (typeof legacyStylePropertiesTypes)[number],
    defaultValue: '',
    state: 'regular',
  },
};

const imageHoverParams = {
  'image-hover-background': {
    type: 'BACKGROUND_FILL' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'image-hover-border-left': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'image-hover-border-right': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'image-hover-border-top': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'image-hover-border-bottom': {
    type: 'BORDER_SIDE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'image-hover-border-top-left-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'image-hover-border-top-right-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'image-hover-border-bottom-left-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'image-hover-border-bottom-right-radius': {
    type: 'BORDER' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'image-hover-padding-left': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'image-hover-padding-right': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'image-hover-padding-top': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'image-hover-padding-bottom': {
    type: 'SIZE' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
  'image-hover-box-shadow': {
    type: 'BOX_SHADOW' as (typeof legacyStylePropertiesTypes)[number],
    state: 'hover',
  },
};

export const fastGallerySkinDefinition: Record<string, SkinDefinition> = {
  'wixui.skins.FastGallery': {
    ...rootParams,
    ...rootHoverParams,
    ...itemParams,
    ...itemHoverParams,
    ...titleParams,
    ...titleHoverParams,
    ...descriptionParams,
    ...descriptionHoverParams,
    ...counterParams,
    ...counterHoverParams,
    ...overlayParams,
    ...overlayHoverParams,
    ...imageParams,
    ...imageHoverParams,
  },
} as const;

export default generateSkinDefaults(fastGallerySkinDefinition);
